module.exports = __webpack_public_path__ + "img/logo.587deca1.svg";